import { Pipe, PipeTransform } from '@angular/core';
import { ServiceManagement } from 'src/models/workshopsManagement.interface';

@Pipe({
    name: 'activeServices',
    standalone: false
})
export class ActiveServicesPipe implements PipeTransform {

  transform(services: ServiceManagement[]): ServiceManagement[] {
    
    return services.filter((service) => service.isActive)

}
}
